/**
 * @generated SignedSource<<617dfe2c4fa778f91e1e490fa39eded2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CancelStage = "CancelImpossible" | "CancelPossibleAfterDeclare" | "CancelPossibleBeforeDeclare" | "CancelPossibleImmediately" | "Canceling";
export type RefundStage = "Declare" | "PaymentComplete" | "RefundCompleteA" | "RefundCompleteB" | "RefundDetermine" | "RefundPreDetermine" | "Review" | "Unknown";
export type RefundStatus = "ApplyComplete" | "ApplyImpossible" | "ApplyPossible" | "Complete" | "Impossible" | "None" | "Possible" | "RefundFinish" | "RefundImpossible" | "Retry";
export type RefundSubStage = "DeclareSpecialFeeA" | "DeclareSpecialFeeB" | "Default" | "ReviewCs" | "ReviewWritingComplete";
import { FragmentRefs } from "relay-runtime";
export type CorpsSection$data = {
  readonly bznavRefund: {
    readonly user: {
      readonly corps: ReadonlyArray<{
        readonly applicationDt: string | null | undefined;
        readonly businessInfo: {
          readonly hometaxBizName: string | null | undefined;
          readonly hometaxBizNo: string | null | undefined;
        } | null | undefined;
        readonly cancelStage: CancelStage | null | undefined;
        readonly lostReason: string | null | undefined;
        readonly office: string | null | undefined;
        readonly partnerInfo: {
          readonly defaultFeeRate: string;
          readonly feeRate: string;
          readonly partnerName: string;
        } | null | undefined;
        readonly paymentAmount: number | null | undefined;
        readonly paymentClosingDt: string | null | undefined;
        readonly refundAmount: string;
        readonly refundId: string;
        readonly refundReportDt: string | null | undefined;
        readonly refundResultDt: string | null | undefined;
        readonly refundResultExpectDt: string | null | undefined;
        readonly refundStage: RefundStage | null | undefined;
        readonly refundStatus: RefundStatus;
        readonly refundSubStage: RefundSubStage | null | undefined;
        readonly tin: string;
        readonly userFee: number | null | undefined;
        readonly virtualAccountInfo: {
          readonly account: string;
          readonly bank: string;
          readonly owner: string;
          readonly paymentAmount: string;
        } | null | undefined;
      }> | null | undefined;
    };
  };
  readonly " $fragmentType": "CorpsSection";
};
export type CorpsSection$key = {
  readonly " $data"?: CorpsSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"CorpsSection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentAmount",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CorpsSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BznavRefundOutput",
      "kind": "LinkedField",
      "name": "bznavRefund",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RefundUserType",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RefundHistoryType",
              "kind": "LinkedField",
              "name": "corps",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refundId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refundStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refundStage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refundSubStage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refundAmount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refundReportDt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refundResultDt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refundResultExpectDt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "paymentClosingDt",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "applicationDt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cancelStage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userFee",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lostReason",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tin",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "office",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VirtualAccountType",
                  "kind": "LinkedField",
                  "name": "virtualAccountInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "owner",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bank",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "account",
                      "storageKey": null
                    },
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RefundPartnerType",
                  "kind": "LinkedField",
                  "name": "partnerInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "partnerName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "feeRate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "defaultFeeRate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BusinessInfo",
                  "kind": "LinkedField",
                  "name": "businessInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hometaxBizName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hometaxBizNo",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "ebc45be1d08a6fe544a03091b671ab78";

export default node;
